"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgToggleEmitZionEvents = exports.MsgCreateEmitEvent = exports.MsgProcessZionCrossChainTxResponse = exports.MsgProcessCrossChainTxResponse = exports.MsgProcessZionCrossChainTx = exports.MsgProcessCrossChainTx = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const params_1 = require("./params");
exports.protobufPackage = "Switcheo.carbon.ccm";
const baseMsgProcessCrossChainTx = {
    submitter: "",
    fromChainId: long_1.default.UZERO,
    proof: "",
    header: "",
    headerProof: "",
    currentHeader: "",
};
exports.MsgProcessCrossChainTx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.submitter !== "") {
            writer.uint32(10).string(message.submitter);
        }
        if (!message.fromChainId.isZero()) {
            writer.uint32(16).uint64(message.fromChainId);
        }
        if (message.proof !== "") {
            writer.uint32(26).string(message.proof);
        }
        if (message.header !== "") {
            writer.uint32(34).string(message.header);
        }
        if (message.headerProof !== "") {
            writer.uint32(42).string(message.headerProof);
        }
        if (message.currentHeader !== "") {
            writer.uint32(50).string(message.currentHeader);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgProcessCrossChainTx);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.submitter = reader.string();
                    break;
                case 2:
                    message.fromChainId = reader.uint64();
                    break;
                case 3:
                    message.proof = reader.string();
                    break;
                case 4:
                    message.header = reader.string();
                    break;
                case 5:
                    message.headerProof = reader.string();
                    break;
                case 6:
                    message.currentHeader = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgProcessCrossChainTx);
        message.submitter =
            object.submitter !== undefined && object.submitter !== null
                ? String(object.submitter)
                : "";
        message.fromChainId =
            object.fromChainId !== undefined && object.fromChainId !== null
                ? long_1.default.fromString(object.fromChainId)
                : long_1.default.UZERO;
        message.proof =
            object.proof !== undefined && object.proof !== null
                ? String(object.proof)
                : "";
        message.header =
            object.header !== undefined && object.header !== null
                ? String(object.header)
                : "";
        message.headerProof =
            object.headerProof !== undefined && object.headerProof !== null
                ? String(object.headerProof)
                : "";
        message.currentHeader =
            object.currentHeader !== undefined && object.currentHeader !== null
                ? String(object.currentHeader)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.submitter !== undefined && (obj.submitter = message.submitter);
        message.fromChainId !== undefined &&
            (obj.fromChainId = (message.fromChainId || long_1.default.UZERO).toString());
        message.proof !== undefined && (obj.proof = message.proof);
        message.header !== undefined && (obj.header = message.header);
        message.headerProof !== undefined &&
            (obj.headerProof = message.headerProof);
        message.currentHeader !== undefined &&
            (obj.currentHeader = message.currentHeader);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgProcessCrossChainTx);
        message.submitter = (_a = object.submitter) !== null && _a !== void 0 ? _a : "";
        message.fromChainId =
            object.fromChainId !== undefined && object.fromChainId !== null
                ? long_1.default.fromValue(object.fromChainId)
                : long_1.default.UZERO;
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : "";
        message.header = (_c = object.header) !== null && _c !== void 0 ? _c : "";
        message.headerProof = (_d = object.headerProof) !== null && _d !== void 0 ? _d : "";
        message.currentHeader = (_e = object.currentHeader) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseMsgProcessZionCrossChainTx = {
    submitter: "",
    fromChainId: long_1.default.UZERO,
    proof: "",
    header: "",
    rawCrossTx: "",
};
exports.MsgProcessZionCrossChainTx = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.submitter !== "") {
            writer.uint32(10).string(message.submitter);
        }
        if (!message.fromChainId.isZero()) {
            writer.uint32(16).uint64(message.fromChainId);
        }
        if (message.proof !== "") {
            writer.uint32(26).string(message.proof);
        }
        if (message.header !== "") {
            writer.uint32(34).string(message.header);
        }
        if (message.rawCrossTx !== "") {
            writer.uint32(42).string(message.rawCrossTx);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgProcessZionCrossChainTx);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.submitter = reader.string();
                    break;
                case 2:
                    message.fromChainId = reader.uint64();
                    break;
                case 3:
                    message.proof = reader.string();
                    break;
                case 4:
                    message.header = reader.string();
                    break;
                case 5:
                    message.rawCrossTx = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgProcessZionCrossChainTx);
        message.submitter =
            object.submitter !== undefined && object.submitter !== null
                ? String(object.submitter)
                : "";
        message.fromChainId =
            object.fromChainId !== undefined && object.fromChainId !== null
                ? long_1.default.fromString(object.fromChainId)
                : long_1.default.UZERO;
        message.proof =
            object.proof !== undefined && object.proof !== null
                ? String(object.proof)
                : "";
        message.header =
            object.header !== undefined && object.header !== null
                ? String(object.header)
                : "";
        message.rawCrossTx =
            object.rawCrossTx !== undefined && object.rawCrossTx !== null
                ? String(object.rawCrossTx)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.submitter !== undefined && (obj.submitter = message.submitter);
        message.fromChainId !== undefined &&
            (obj.fromChainId = (message.fromChainId || long_1.default.UZERO).toString());
        message.proof !== undefined && (obj.proof = message.proof);
        message.header !== undefined && (obj.header = message.header);
        message.rawCrossTx !== undefined && (obj.rawCrossTx = message.rawCrossTx);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgProcessZionCrossChainTx);
        message.submitter = (_a = object.submitter) !== null && _a !== void 0 ? _a : "";
        message.fromChainId =
            object.fromChainId !== undefined && object.fromChainId !== null
                ? long_1.default.fromValue(object.fromChainId)
                : long_1.default.UZERO;
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : "";
        message.header = (_c = object.header) !== null && _c !== void 0 ? _c : "";
        message.rawCrossTx = (_d = object.rawCrossTx) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgProcessCrossChainTxResponse = {};
exports.MsgProcessCrossChainTxResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgProcessCrossChainTxResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgProcessCrossChainTxResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgProcessCrossChainTxResponse);
        return message;
    },
};
const baseMsgProcessZionCrossChainTxResponse = {};
exports.MsgProcessZionCrossChainTxResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgProcessZionCrossChainTxResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgProcessZionCrossChainTxResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgProcessZionCrossChainTxResponse);
        return message;
    },
};
const baseMsgCreateEmitEvent = {
    creator: "",
    toChainId: long_1.default.UZERO,
    crossChainId: long_1.default.UZERO,
};
exports.MsgCreateEmitEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.toChainId.isZero()) {
            writer.uint32(16).uint64(message.toChainId);
        }
        if (!message.crossChainId.isZero()) {
            writer.uint32(24).uint64(message.crossChainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateEmitEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.toChainId = reader.uint64();
                    break;
                case 3:
                    message.crossChainId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateEmitEvent);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.toChainId =
            object.toChainId !== undefined && object.toChainId !== null
                ? long_1.default.fromString(object.toChainId)
                : long_1.default.UZERO;
        message.crossChainId =
            object.crossChainId !== undefined && object.crossChainId !== null
                ? long_1.default.fromString(object.crossChainId)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.toChainId !== undefined &&
            (obj.toChainId = (message.toChainId || long_1.default.UZERO).toString());
        message.crossChainId !== undefined &&
            (obj.crossChainId = (message.crossChainId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreateEmitEvent);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.toChainId =
            object.toChainId !== undefined && object.toChainId !== null
                ? long_1.default.fromValue(object.toChainId)
                : long_1.default.UZERO;
        message.crossChainId =
            object.crossChainId !== undefined && object.crossChainId !== null
                ? long_1.default.fromValue(object.crossChainId)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgToggleEmitZionEvents = { creator: "", toggleTo: false };
exports.MsgToggleEmitZionEvents = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.toggleTo === true) {
            writer.uint32(16).bool(message.toggleTo);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgToggleEmitZionEvents);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.toggleTo = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgToggleEmitZionEvents);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.toggleTo =
            object.toggleTo !== undefined && object.toggleTo !== null
                ? Boolean(object.toggleTo)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.toggleTo !== undefined && (obj.toggleTo = message.toggleTo);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgToggleEmitZionEvents);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.toggleTo = (_b = object.toggleTo) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
const baseMsgUpdateParams = { authority: "" };
exports.MsgUpdateParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            params_1.ParamsToUpdate.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = params_1.ParamsToUpdate.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.ParamsToUpdate.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined &&
            (obj.params = message.params
                ? params_1.ParamsToUpdate.toJSON(message.params)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.ParamsToUpdate.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseMsgUpdateParamsResponse = {};
exports.MsgUpdateParamsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Process = this.Process.bind(this);
        this.ProcessZion = this.ProcessZion.bind(this);
        this.ProcessToggleEmitZionEvents =
            this.ProcessToggleEmitZionEvents.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    Process(request) {
        const data = exports.MsgProcessCrossChainTx.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.ccm.Msg", "Process", data);
        return promise.then((data) => exports.MsgProcessCrossChainTxResponse.decode(new minimal_1.default.Reader(data)));
    }
    ProcessZion(request) {
        const data = exports.MsgProcessZionCrossChainTx.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.ccm.Msg", "ProcessZion", data);
        return promise.then((data) => exports.MsgProcessZionCrossChainTxResponse.decode(new minimal_1.default.Reader(data)));
    }
    ProcessToggleEmitZionEvents(request) {
        const data = exports.MsgToggleEmitZionEvents.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.ccm.Msg", "ProcessToggleEmitZionEvents", data);
        return promise.then((data) => exports.MsgProcessCrossChainTxResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.ccm.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
